import { ChangeDetectionStrategy, Component, inject, InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';
import ProjectLinks from 'src/app/common/project.links';
import { InformationMessage, MessageLevel } from 'src/app/interfaces';
import { NotificationState } from '../../notifications.state';
import { DialogActionTypes } from '../dialogs.enum';

export const INFORMATION_DIALOG_DATA = new InjectionToken<InformationMessage>(`INFORMATION_DIALOG_DATA`);
@Component({
  selector: 'app-information-modal',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationDialogComponent extends NotificationState {
  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);
  public readonly message = inject(INFORMATION_DIALOG_DATA);

  protected notificationLevel: MessageLevel = this.message.level;

  public readonly REGISTRATION_LINK: string = ProjectLinks.LINK_REGISTRATION;

  public get hasActions(): boolean {
    return this.message.replies.length !== 0;
  }

  public invokeCallback(callback: () => void): void {
    callback();
    this.closeDialog();
  }

  public actionsHandler(_action: DialogActionTypes): void {
    // Simply ignore
  }

  public submit(_data: string): void {
    // Simply ignore
  }
}
